module.exports = __webpack_public_path__ + "static/media/image_404.55e767cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/image_404.png
// module id = 925
// module chunks = 0